import { useState } from 'react';
import axios from 'axios';
import CONFIG from '../../constanta/config';
import Cookies from 'js-cookie';

export default function SurveyFormDay2(props) {
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const [msgerror, setMsgerror] = useState('');

  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};
    let firstErrorId = null; // 🔥 simpan error pertama

    questions.forEach((q) => {
      // RADIO / TEXTAREA / RATING
      if (q.type === "radio" || q.type === "textarea" || q.type === "rating") {
        if (!answers[q.id]) {
          newErrors[q.id] = true;

          if (!firstErrorId) {
            firstErrorId = q.id;
          }
        }
      }

      // MATRIX
      if (q.type === "rating-matrix") {
        q.items.forEach((item) => {
          if (!answers[item.id]) {
            newErrors[item.id] = true;

            if (!firstErrorId) {
              firstErrorId = item.id; // 🔥 ambil item pertama yg error
            }
          }
        });
      }
    });

    setErrors(newErrors);

    // 🚀 SCROLL KE ERROR PERTAMA
    if (firstErrorId) {
      setTimeout(() => {
        const el = document.getElementById(`question-${firstErrorId}`);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
    }

    return Object.keys(newErrors).length === 0;
  };

  const moveUp = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index - 1], newItems[index]] =
          [newItems[index], newItems[index - 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const moveDown = (qId, index) => {
    setQuestions(prev =>
      prev.map(q => {
        if (q.id !== qId) return q;

        const newItems = [...q.items];
        [newItems[index + 1], newItems[index]] =
          [newItems[index], newItems[index + 1]];

        return { ...q, items: newItems };
      })
    );
  };

  const [questions, setQuestions] = useState([

    {
      no: '1',
      id: '101',
      question: 'What is your age range?',
      type: 'radio',
      options: ['18-24', '25-29', '30-34', '35-39', '40-44', '45 and over']
    },
    {
      no: '2',
      id: '102',
      question: 'Which country are you located?',
      type: 'radio',
      options: [
        'Anguilla',
        'Guyana',
        'Antigua and Barbuda',
        'Haiti',
        'Aruba',
        'Jamaica',
        'Bahamas',
        'Saba',
        'Barbados',
        'Martinique',
        'Belize',
        'Montserrat',
        'Bermuda',
        'Saint Kitts and Nevis',
        'Bonaire',
        'Saint Lucia',
        'St. Eustatius',
        'Sint Maarten',
        'British Virgin Islands',
        'Saint Vincent and the Grenadines',
        'Cayman Islands',
        'Suriname',
        'Curacao',
        'Trinidad and Tobago',
        'Dominica',
        'Turks and Caicos',
        'Grenada',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '3',
      id: '103',
      question: 'Type of Institution',
      type: 'radio',
      options: [
        'Academia',
        'Public Sector',
        'Private Sector',
        'Government',
        'Non-Governmental Organisation',
        'Inter-Governmental Organisation',
        'Civil Society Organisation',
        'Other'
      ],
      hasOther: true
    },
    {
      no: '4',
      id: '104',
      question: 'Do you operate (work/study) in a health-related field?',
      type: 'radio',
      options: ['Yes', 'No']
    },
    {
      no: '5',
      id: '105',
      question:
        'Please rate the following aspects of the Oral Presentation Sessions:',
      type: 'rating-matrix',
      items: [
        { id: '106', label: 'Scientific content' },
        { id: '107', label: 'Clarity of presentation' },
        { id: '108', label: 'Quality of slides' },
        { id: '109', label: 'Discussion' },
        { id: '110', label: 'Time management' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '6',
      id: '111',
      question:
        "Which session and/or oral presentation under 5a: Women's Health was the most outstanding?",
      type: 'radio',
      options: [
        "0-29: Suffering in silence: endometriosis and the Caribbean research gap.",
        "0-30: A cross-sectional survey of stigma, anxiety, and depression in women with endometriosis and/or uterine fibroids in Barbados.",
        "0-31: Investigating the association of drug exposure during pregnancy with birth outcomes, among mothers with medicaid.",
        "0-32: A review of hypertensive disorders of pregnancy between January 2023 and December 2023 at the Queen Elizabeth Hospital, Barbados",
        "Not applicable"
      ]
    },
    {
      no: '7',
      id: '112',
      question:
        'Which session and/or oral presentation under 5b: Mental Health was the most outstanding?',
      type: 'radio',
      options: [
        "0-33: Increased emotional resilience and mental well-being in Virgin Islands (UK) Youths through early therapeutic intervention.",
        "0-34: Relational, cultural and collective pathways to indigenous adolescent well-being: process evaluation of the IMPACT (Implementation of a Multisectoral Programme To Improve Indigenous Adolescent Mental Health) programme in Brazil.",
        "0-35: Grounding youth mental health indigenous knowledge systems and adolescent mental health: Photovoice Findings from the IMPACT Programme in Brazil.",
        "0-36: Strengthening Primary mental health care in Small Island Developing States; Lessons from the GGZ-Carib Participatory Action Research Project in Curaçao and Bonaire.",
        'Not Applicable.'
      ]
    },
    {
      no: '8',
      id: '113',
      question:
        'Which session and/or oral presentation under 5c: Poster Session 1 was the most outstanding?',
      type: 'radio',
      options: [
        "P-01: Misinformed and misled: digital health misinformation as a barrier to care.",
        "P-02: Building local capacity with regional impact: a community partnership between the Grenada Red Cross Society and the University of Michigan School of Public Health.",
        "P-03- The Caribbean Cure? Exploring Irish sea moss as a natural remedy for autoimmune conditions, hypertension, and gut health.",
        "P-04: Evaluating a 10-year community academic partnership in Grenada.",
        "P-05: Building health together: a longstanding collaboration between the University of Michigan School of Public Health Action Support Team and Caribbean nation of Grenada.",
        "P-06: Factors affecting blood wastage at the national blood transfusion service in Guyana in 2023.",
        "P-07: Evaluation of faculty workplace attendance and academic performance in higher education.",
        "P-08: Assessment of pet ownership and its impact on human health in Grenada.",
        "P-09: Food safety knowledge, attitudes and practices among abattoir workers in the municipalities of region 4 and 5, Guyana.",
        "P-10: Prospective study of limited high-dependency unit space on emergency patient outcomes in Guyana.",
        "P-11: Research on Guyana in a global context: bibliometric insights for strengthening Caribbean public health collaboration.",
        "P-12: Alterations in standard DNA methylation patterns associated with exclusive e-cigarette use: a scoping review.",
       'Not Applicable.'
      ]
    },
    {
      no: '9',
      id: '114',
      question:
        'Which session and/or oral presentation under 6a: Family Health was the most outstanding?',
      type: 'radio',
      options: [
        "0-37: Evaluating management strategies for late pregnancy loss: a randomized clinical trial at Georgetown Public Hospital Corporation.",
        "0-38: The effectiveness of the HPV Quadrivalent vaccine in Guyanese women.",
        "0-39: Improving protection against and our understanding of Human Papillomavirus infection in the Cayman Islands using a multi-faceted approach.",
        "0-40: Self-Rated health as a predictor of short to long-term survival in older Afro-Caribbeans hospitalised via the emergency department.",
        "0-41: Factors associated with quality of life among elderly Bahamians attending selected primary care clinics in New Providence, Bahamas: a cross sectional study.",
        "0-42: Integrating muscle damage, immune function and electrolyte balance biomarkers for early detection of training stress in collegiate athletes during pre-season in Jamaica.",
        'Not Applicable.'
      ]
    },

    {
      no: '10',
      id: '115',
      question:
        'Which session and/or oral presentation under 6b: Mental Health was the most outstanding?',
      type: 'radio',
      options: [
      "0-43: Racism, immigration background, and adolescent mental health: an intersectional analysis of the London based DASH multi-ethnic cohort.",
      "0-44: An analysis of the prevalence of depression among medical staff at Georgetown Public Hospital Corporation (GPHC): a cross-sectional study.",
      "0-45: Mental Health and adaption to chronic sargassum exposure in the French Overseas Territories in the Americas.",
      "0-46: Exploring mental well-being and psychological distress in Caribbean EMS/Fire Providers: a cross-sectional study.",
      "0-47: Mental wellbeing and psychological distress among first- and second or higher-generation English-speaking Caribbean Immigrants in New York City (NYC).",
      "0-48: Strengthening indigenous community mental health capacity in Dominica an mHGAP-informed training in the implementation of a multisectoral programme to improve Indigenous Adolescent Mental Health (IMPACT) study.",
        'Not Applicable.'
      ]
    },

    {
      no: '11',
      id: '116',
      question:
        'Which session and/or oral presentation under 6c: Poster Session 2 was the most outstanding?',
      type: 'radio',
      options: [
      "P-13: The knowledge, attitudes and practices of parents of adolescents, regarding public dental services in Trinidad and Tobago.",
      "P-14: Implementation of the Innovative, advanced, digitized Caribbean Vessel Surveillance System (CVSS) to promote healthier, safer cruise tourism.",
      "P-15: Epidemiological assessment of maxillofacial fractures at the Georgetown Public Hospital Corporation: s retrospective study from January 2019 to December 2024.",
      "P-16: Outcomes of non-dominant radiocephalic arteriovenous fistulas at Georgetown Public Hospital.",
      "P-17: Implementing and evaluating culturally appropriate and standardized training methodologies: life support in obstetric emergencies course in Guyana.",
      "P-18: A narrative approach to explore the perceptions of battered women and support personnel to social support network and services in Trinidad.",
      "P-19: Primary care physicians cognizance of screening intimate partner violence among the antenatal population in region 4 in Guyana.",
      "P-20: Improving Postpartum quality of life through social support: a cross-sectional study at the Campbellville Health Center.",
      "P-21: To determine the knowledge, attitudes, and practices related to polycystic ovary syndrome among women of reproductive age attending the Gynaecology Outpatient Clinic at West Demerara Regional Hospital.",
      "P-22: A study on knowledge. attitude and practice of mothers regarding antenatal care, labor, delivery and postpartum hemorrhage in Region 3, Guyana.",
      "P-23: Pre-eclampsia Prevalence and Maternal and Neonatal Outcomes: A 2023 Retrospective Analysis at West Demerara Regional Hospital.",
      "P-24: One-year continuation of long-acting reversible contraceptives following placement at the Georgetown Public Hospital Corporation Family Planning Clinic, June 2023-2024.",
      "P-25: Clinicopathological characteristics of primary breast cancer among women: a descriptive study.",
      "P-26: Is lifestyle medicine a viable economic response to the Caribbean noncommunicable diseases burden?",
      "P-27: Children and youth as agents of change in school health promotion: participatory lessons from the Caribbean.",
      "P-28: Food security as a public health ethic: addressing the dilemma of import dependence in the Caribbean.",
      "P-29: Exploring schools drinking water availability as leverage for sugar sweetened beverage ban in schools.",
      "P-30: A cross-sectional study on self-perceived comfort and competence of doctors and nurses during code blue events at Georgetown Public Hospital Corporation from August to September 2025: Identifying factors affecting response readiness.",
        'Not Applicable.'
      ]
    },
    {
      no: '12',
      id: '117',
      question:
        'Which session and/or oral presentation under 7a: Infectious Diseases: HIV was the most outstanding?',
      type: 'radio',
      options: [
        "0-49: Sustained HIV protection with Cabotegravir LA among black and latine Individuals: data from the Midway cohort.",
        "0-50: Predicting virological failure in pediatric and adolescent human immunodeficiency virus (HIV) patients in Haiti: a crisis-adjusted machine learning approach.",
        "0-51: Countdown to Control: Viral Suppression in Older Adults with HIV from Midway Cohort.",
        "0-52: Feasibility and impact of rapid diagnostic screening for opportunistic infections among people with advanced HIV disease in Guyana: a prospective multicenter study.",
        "0-53: Factors influencing adherence to antiretroviral therapy and engagement in HIV care at the National Care and Treatment Centre in Guyana: a retrospective chart review.",
        "0-54: Loss to follow-up in HIV care: a retrospective analysis in Belize City, 2019 - 2024.",
        'Not Applicable.'
      ]
    },
    {
      no: '13',
      id: '118',
      question:
        'Which session and/or oral presentation under 7b Public Health was the most outstanding?',
      type: 'radio',
      options: [
        "0-55: Innovation through listening redesigning mental health services in Guyana based on community identified needs.",
        "0-56: A preliminary assessment of counterfeit acetaminophen containing painkillers in kingston, Jamaica using high performance liquid chromatography.",
        "0-57: Lived experiences of artisanal and small-scale gold mining in northen Nigeria: a photovoice study with global public health implications.",
        "0-58: Building healthy communities with the tripartite goal of chronic disease prevention, environmental sustainability, and engaging youth as agents of change: lessons learned and next steps.",
        "0-59: Toxic Beauty: carcinogenic substances in beauty products and the ethical responsibility of Caribbean market regulation.",
        "0-60: Profile of voluntary blood donors in Jamaica.",
        'Not Applicable.'
      ]
    },
    {
      no: '14',
      id: '119',
      question:
        'Which session and/or oral presentation under 7c: Poster Session 3 was the most outstanding?',
      type: 'radio',
      options: [
        "P-31: Prevalence of catheter-related bloodstream infections in hemodialysis patients at Georgetown Public Hospital, Guyana: a retrospective analysis (2023).",
        "P-32: Nurses/TB outreach workers views on the actors linked to poor treatment adherence among tuberculosis patients.",
        "P-33: Integrating geospatial technologies into the Public Health Approach to fight crime and violence in the Caribbean.",
        "P-34: Performance and integrity across proctored physical, unprotected online, and proctored online formats in the UWI Final MBBS Medicine & Therapeutics written examination.",
        "P-35: Exploring the use of reflective practice in clinical skills development among nursing students during their clinical rotation at Georgetown Public Hospital Corporation, Guyana.",
        "P-36: The effectiveness of training primary care doctors using the Grieg's Record for Young Adults between 18 and 24 years.",
        "P-37: An evaluation of the unified MBBS Exit Examination at the University of the West Indies.",
        "P-38: The influence of mentorship on clinical preparedness: a comparison of Georgetown and St. Joseph Mercy Hospital School of Nursing Students.",
        "P-39: Determining the minimum number of OSCE stations required for valid and reliable assessment in the final MBBS Examination.",
        "P-40: Usage patterns of artificial intelligence tools among pre-medical and basic science medical students at Texila American University, Guyana.",
        "P-41: Medical students perspective on integration climate-health education into medical school curricula in Guyana.",
        "P-42: Faculty perspective on integration climate-health education into undergraduate medical curricula in Guyana.",
        "P-43: A phenomenological study of the traumatic impacts of suicide on survivors: a Guyanese perspective.",
        "P-44: Creative interventions for climate-related mental health and resilience in Caribbean and diasporic communities.",
        "P-45: Brief mental health measures for university students in Barbados: Psychometric properties of the Perceived Stress Scale-4 and Patient Health Questionnaire-4.",
        "P-46: Exploring factors influencing the delivery of community-based salon interventions to prevent cardiovascular disease among ethnically diverse women in England: The Beauty and Health Community Lounges (BELONG) Study.",
        "P-47: Participatory intercultural adaptation of the WHO mhGAP for kaingang adolescents in Brazil: integrating indigenous knowledge",
        "P-48: A qualitative study exploring awareness of and access to mental health support and the role of the community pharmacist in facilitating such support for patients living with systemic rheumatic conditions in Trinidad and Tobago.",
        'Not Applicable.'
      ]
    },
    {
      no: '15',
      id: '120',
      question:
        "Which session and/or oral presentation under 8a. Infectious Diseases: Vectors was the most outstanding?",
      type: 'radio',
      options: [
        "0-61: Smart traps and internet of things-based entomological surveillance integrated with artificial intelligence for real-time mosquito density mapping.",
        "0-62: Molecular surveillance of the invasive Aedes vittatus in Jamaica.",
        "0-63: Predictive factors and early management of severe dengue fever in emergency and intensive care units in Martinique during the 2023-2024 epidemic.",
        "0-64: Innovations in dengue surveillance serotype distribution, transmission dynamics, and implications for outbreak preparedness in Guyana, South America.",
        "0-65: Evaluation of the acute and subacute toxicity of Myristica fragrans essential oil against Aedes aegypti mosquitoes.",
        "0-66: Distribution of mosquito species in select communities of regions one, four, six, seven and nine in Guyana in 2025.",
        "0-67: High seroprevalence of anti-dengue virus IgG antibodies in the Sud Department of Haiti: a population-based cross-sectional study.",
        "0-68: A pilot elimination strategy for Plasmodium falciparum malaria in mining associated endemic settings: a case study from South Rupununi Region 9, Guyana.",
        'Not Applicable.'
      ]
    },
    {
      no: '16',
      id: '121',
      question:
        "Which session and/or oral presentation under 8b. Nutrition was the most outstanding?",
      type: 'radio',
      options: [
        "0-69: Changes in food literacy following an education intervention: findings from the BALANCE study.",
        "0-70: Sociodemographic correlations of change in food literacy following an education intervention: Findings from the BALANCE study.",
        "0-71: The adaptation and implementation of an automated 24-hour dietary recall tool for Caribbean populations : St. Vincent and the Grenadines pilot study.",
        "0-72: Assessing the school nutrition and physical activity environment two years post implementation of Barbados' School Nutrition Policy.",
        "0-73: A tale of two interventions: co-creation and implementation of context-driven interventions to support local food production and consumption in two Caribbean countries.",
        "0-74: Nutritional content and dietary inflammatory index (DII) of foods consumed by Systematic Lupus Erythematosus (SLE) sub-population in Barbados.",
        "0-75: Exploring stakeholders' perceptions on the implementation of a school nutrition policy in Small Island Developing State: the Barbados case study.",
        "0-76: Food consumption patterns of people living with diabetes in Trinidad.",
        'Not Applicable.'
      ]
    },
    {
      no: '17',
      id: '122',
      question:
        "Which session and/or oral presentation under 8c: Poster Session 4 was the most outstanding?",
      type: 'radio',
      options: [
        "P-49: Psychological effects on parents of hospitalized children in Georgetown Public Hospital Corporation, January 2022- August 2024.",
        "P-50: Innovating access to adult attention deficit hyperactivity disorder care in the Caribbean: early experience from an online Specialist mental health service.",
        "P-51: Bidirectional risks of obesity and mental health disorders: a systematic review and meta-analysis.",
        "P-52: Prevalence and outcomes of triple negative breast cancer in female patients at the Oncology Department, Georgetown Hospital Corporation, January 2019 to January 2024.",
        "P-53: Cross-border cancer care in the Caribbean: a retrospective analysis of applicants of government medical assistance in Saint Lucia.",
        "P-54: Diabetes mellitus and gynecological cancers in a tertiary hospital in Guyana: exploring correlations, risk factors and outcomes.",
        "P-55: Collaborative development of diabetes screening and management guidelines in Guyana.",
        "P-56: A retrospective study highlighting the survival rates of renal failure patients pending kidney transplantation between 2018 and 2023 at the Georgetown Public Hospital Corporation.",
        "P-57: Remission in schizophrenia across the illness course: a critical review of constructs, stability, and relapse.",
        "P-58: (Pre-recording) Oral Health Indicators Among Exclusive Electronic Nicotine Delivery System Users.",
        "P-59: (Pre-recording) The Association of the HEARTS Regimen with Blood Pressure Control Among Patients with Hypertension Attending Primary Health Care Facilities at the South-West Regional Health Authority, Trinidad.",
        "P-60: (Pre-recording) Physical activity and insomnia severity in adults with type-2 diabetes in Trinidad: a sequential mixed-methods study protocol.",
        'Not Applicable.'
      ]
    },
    {
      no: '18',
      id: '123',
      question: 'Please rate the following aspects of the Poster Presentations',
      type: 'rating-matrix',
      items: [
        { id: '124', label: 'Scientific content' },
        {
          id: '125',
          label: 'Clarity of presentation [if video was viewed/accessible]'
        },
        { id: '126', label: 'Visual impact' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
      no: '19',
      id: '127',
      question:
        'Please select a rating for the following aspects of the event facilities:',
      type: 'rating-matrix',
      items: [
        { id: '128', label: 'Secretariat support' },
        {
          id: '129',
          label:
            'Physical venue: ease of accessing location and organization of lecture & session rooms'
        },
        {
          id: '130',
          label:
            'Engagement at Location: discussions with presenters/exhibitors and other attendees'
        },
        {
          id: '131',
          label: 'Display and presentation of Exhibition Booths at the location'
        },
        { id: '132', label: 'Technical support for participants on location' },
        { id: '133', label: 'Selection and Quality of Food' }
      ],
      scale: ['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']
    },
    {
        no: "20",
        id: "134",
        question: "What were your expectations/goals for attending this Conference? Please rank options below, with 1 as the highest goal and 6 as the lowest?",
        type: "ranking",
        items: [
          { id: "135", label: "Gaining more subject matter expertise or expanding your knowledge and find solutions to problems" },
          { id: "136", label: "Network for future collaborations" },
          { id: "137", label: "Peer discussion of new research for application" },
          { id: "138", label: "To find about out more about public health in the Caribbean region" },
          { id: "139", label: "Improve research skills set" },
          { id: "140", label: "Presentation of a research paper" }
        ],
        originalItems: [
            { id: "135" },
            { id: "136" },
            { id: "137" },
            { id: "138" },
            { id: "139" },
            { id: "140" }
          ]
      },
    {
      no: '21',
      id: '141',
      question:
        'Where there any standout moments or experiences during the conference?',
      type: 'textarea'
    },
    {
      no: '22',
      id: '142',
      question:
        'On a scale of 1 to 10, how likely are you to recommend the CARPHA Conference to a friend or colleague?',
      type: 'rating',
      scale: 10
    },
    {
      no: '23',
      id: '143',
      question:
        'Please state below any general comments or suggestions for improvement in the future.',
      type: 'textarea'
    },
    {
      no: '24',
      id: '144',
      question: 'CME Credits - Day 2 Only (April 23, 2026) - 7.75 Credits',
      type: 'radio',
      options: ['Apply Credits', 'Not Required']
    }
  ]);

  const handleChange = (id, value) => {
    setAnswers(prev => ({
      ...prev,
      [id]: value
    }));

    // 🔥 HAPUS ERROR SAAT USER ISI
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });
  };

  const handleSubmit = () => {
    if (!validate()) {
        alert("Please complete all questions first");
        return;
      }

      let survey = [];

      // 🔹 normal answers
      Object.keys(answers).forEach(key => {
        survey.push({
          id_question: key,
          answer: answers[key]
        });
      });

      // 🔥 ranking answers (INI YANG KAMU MAU)
      questions.forEach(q => {
        if (q.type === "ranking") {
            q.items.forEach((item, index) => {
                survey.push({
                  id_question: q.originalItems[index].id, // 🔥 ID tetap
                  answer: item.label                      // 🔥 label geser
                });
              });
        }
      });



    const payload = {
      id_user: props?.user?.id_user,
      day: 2,
      json: JSON.stringify({
        survey : survey
      })
    };

      var form_data = new FormData();

      for (var key in payload) {
        form_data.append(key, payload[key]);
      }

      setLoading(true);
      setMsgerror("");

      axios
        .post(CONFIG.URL + '/survey/submit', form_data, {
          headers: {
            token: CONFIG.TOKEN_SURVEY
          }
        })
        .then(function (response) {
          setLoading(false);
          if (response?.data?.status === 'SUCCESS') {
props.onSuccess()
          } else {
          }
        })
        .catch(function (error) {});

  };

  return (
    <div className="w-full mx-auto space-y-2">

      <div className="w-full bg-white">
      <hr className='my-2'/>
      <div className="text-black flex flex-col font-bold my-2 text-2xl text-center">
                <span className="text-4xl"> {props?.user?.name}</span>
                <span className="text-lg text-black mt-2">
                  {props?.user?.position}
                </span>
                <span className="text-lg text-black mt-2">{props?.user?.company}</span>

              </div>

              <hr className='my-2'/>
        {/* TOP TITLE BAR */}
        <div className="bg-slate-600 text-white text-center py-6 px-4">
          <h1 className="text-xl md:text-2xl font-bold tracking-wide">
            CARPHA 70TH ANNUAL HEALTH RESEARCH CONFERENCE
          </h1>
          <p className="text-lg md:text-xl font-semibold mt-1">
            EVALUATION FORM – Day 2
          </p>
        </div>

        {/* CONTENT */}
        <div className="max-w-4xl mx-auto px-6 py-8 space-y-6">
          <h2 className="text-xl font-bold">
            Welcome to the CARPHA 70TH Annual Health Research Conference
            Evaluation
          </h2>

          <p className="text-gray-700 leading-relaxed">
            Please share your conference experience by completing this survey.
            Your feedback is important to assist with improving our Annual
            Health Research Conference. All your responses are anonymous and
            confidential as CARPHA would not be collecting any personal
            information. If you click the survey link, you are stating that you
            understand that your participation in this survey is completely
            voluntary.
          </p>
        </div>
      </div>

      {questions.map((q) => {
        const hasMatrixError =
        q.type === "rating-matrix" &&
        q.items.some(item => errors[item.id]);

        return ( <div
          id={`question-${q.id}`}
            key={q.id}
             className={`p-4 border rounded-xl shadow-sm ${
        errors[q.id] || hasMatrixError
          ? "border-red-500"
          : "border-gray-200"
      }`}>
            <p className="font-semibold mb-3">
              {q.no}. {q.question}
            </p>

            {/* RADIO */}
            {q.type === 'radio' && (
              <div className="flex flex-wrap gap-2">
                {q.options.map((opt) => {
                  const isSelected = answers[q.id] === opt;

                  return (
                    <button
                      key={opt}
                      type="button"
                      onClick={() => handleChange(q.id, opt)}
                      className={`
              px-4 py-2 rounded-lg border text-sm transition text-left
              ${
                isSelected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white hover:bg-blue-50 border-gray-300'
              }
            `}>
                      {opt}
                    </button>
                  );
                })}

                {/* OTHER INPUT */}
                {q.hasOther && (
                  <input
                    type="text"
                    placeholder="Other..."
                    className="w-full border p-2 rounded mt-2"
                    onChange={(e) => handleChange(q.id, e.target.value)}
                  />
                )}
              </div>
            )}

{q.type === "ranking" && (
  <div className="space-y-2">
    {q.items.map((item, index) => (
      <div
        key={item.id}
        className="flex items-center justify-between border p-2 rounded"
      >
        <span className="text-sm">
          {index + 1}. {item.label}
        </span>

        <div className="flex gap-2">
          <button
            type="button"
            disabled={index === 0}
            onClick={() => moveUp(q.id, index)}
            className="px-2 border rounded"
          >
            ↑
          </button>

          <button
            type="button"
            disabled={index === q.items.length - 1}
            onClick={() => moveDown(q.id, index)}
            className="px-2 border rounded"
          >
            ↓
          </button>
        </div>
      </div>
    ))}
  </div>
)}

            {/* TEXTAREA */}
            {q.type === 'textarea' && (
              <textarea
                className="w-full border p-2 rounded"
                rows="3"
                onChange={(e) => handleChange(q.id, e.target.value)}
              />
            )}

            {/* RATING 1-10 */}
            {q.type === 'rating' && (
              <div className="space-y-2">
                {/* Label kiri kanan */}
                <div className="flex justify-between text-xs text-gray-500">
                  <span>Not at all likely</span>
                  <span>Extremely likely</span>
                </div>

                {/* Button rating */}
                <div className="flex w-full gap-2">
                  {Array.from({ length: q.scale }, (_, i) => i + 1).map((num) => {
                    const isActive = answers[q.id] === num;

                    return (
                      <button
                        key={num}
                        type="button"
                        onClick={() => handleChange(q.id, num)}
                        className={`
                 h-10 rounded-lg border text-sm font-medium w-full
                transition-all duration-150
                ${
                  isActive
                    ? 'bg-blue-600 text-white border-blue-600 scale-110 shadow'
                    : 'bg-white border-gray-300 hover:bg-blue-50'
                }
              `}>
                        {num}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {q.type === 'rating-matrix' && (
              <div className="space-y-4">
                {q.items.map((item) => {
                  const selected = answers[item.id];

                  return (
                    <div id={`question-${item.id}`} key={item.id}>
                      <p className="text-sm font-medium mb-2">{item.label}</p>

                      <div className="flex w-full gap-2">
                        {q.scale.map((scale) => {
                          const isActive = selected === scale;

                          return (
                            <button
                              key={scale}
                              type="button"
                              onClick={() => handleChange(item.id, scale)}
                              className={`w-full
                      px-3 py-1.5 text-xs rounded-lg border transition
                      ${
                        isActive
                          ? 'bg-blue-600 text-white border-blue-600'
                          : 'bg-white border-gray-300 hover:bg-blue-50'
                      }
                    `}>
                              {scale}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

{(errors[q.id] || hasMatrixError) && (
  <p className="text-red-500 text-sm mt-2">
   This field is required
  </p>
)}
          </div>)
      }



      )


      }

{msgerror !== '' && (
                <div className="w-full max-w-lg text-center py-2 px-2 rounded-md my-2  text-red-500 font-bold">
                  {msgerror}
                </div>
              )}

       <div className='flex w-full gap-4'>
        <button
         onClick={() => props.handleCancel()}
          className="bg-red-600 text-white px-4 py-2 rounded w-max">
          Cancel
        </button>
        <button
        disabled={loading}
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-4 py-2 rounded w-full">
         {loading ? "Submitting..." : "Submit Survey"}
      </button>
      </div>
    </div>
  );
}
